import { asDarkSvg, asDisabledSvg, asLightSvg } from '../../hocs';
import SidebarAlignRightSvg from './SidebarAlignRightSvg';

const LightSidebarAlignRightSvg = asLightSvg(SidebarAlignRightSvg);
const DarkSidebarAlignRightSvg = asDarkSvg(SidebarAlignRightSvg);
const DisabledSidebarAlignRightSvg = asDisabledSvg(SidebarAlignRightSvg);

export default SidebarAlignRightSvg;
export { SidebarAlignRightSvg, LightSidebarAlignRightSvg, DarkSidebarAlignRightSvg, DisabledSidebarAlignRightSvg };
